/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Mode_BlocksInputs */

const cs_builder_mode_blocks = /** @type {(inputs: Builder_Mode_BlocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizuální`)
};

const en_builder_mode_blocks = /** @type {(inputs: Builder_Mode_BlocksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visual`)
};

/**
* | output |
* | --- |
* | "Visual" |
*
* @param {Builder_Mode_BlocksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_mode_blocks = /** @type {((inputs?: Builder_Mode_BlocksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Mode_BlocksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_mode_blocks(inputs)
	return cs_builder_mode_blocks(inputs)
});